import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchBodyshop() {
  try {
    const dealerInfo = yield call(function() {
      return Api.get('/dealer/info')
    });
    yield put({type: 'FETCH.DEALER_INFO.SUCCESS', dealerInfo});
  } catch (error) {
    yield put({type: 'FETCH.DEALER_INFO.FAILURE', error});
  }
}

export function* watchFetchDealerInformation() {
  yield takeEvery('FETCH.DEALER_INFO.REQUEST', fetchBodyshop)
  yield takeEvery('SAVE.DEALER_INFO.REQUEST', saveBodyshop)
  yield takeEvery('FETCH.MY_DEALER.REQUEST', fetchMyDealer)
}

function* saveBodyshop(action) {
  try {
    const dealerInfo = yield call(function () {
      return Api.post('/dealer/info', action.body);
    });
    yield put({type: 'SHOW_NOTIFICATION', notification:{message:'save.success'}});
    yield put({type: 'FETCH.DEALER_CONFIGURATION_CHECK.REQUEST'});
    yield put({type: 'SAVE.DEALER_INFO.SUCCESS', dealerInfo});
  } catch (error) {
    yield put({type: 'SAVE.DEALER_INFO.FAILURE', error})
  }
}

function* fetchMyDealer(action) {
  try {
    const dealer = yield call(function() {
      return Api.get(`/my/dealer?connectedId=${action.params.connectedId}`)
    });
    yield put({type: 'FETCH.MY_DEALER.SUCCESS', dealer});
  } catch (error) {
    yield put({type: 'FETCH.MY_DEALER.FAILURE', error});
  }
}
